import { render, staticRenderFns } from "./bank-info.vue?vue&type=template&id=44201116&scoped=true"
import script from "./bank-info.vue?vue&type=script&lang=js"
export * from "./bank-info.vue?vue&type=script&lang=js"
import style0 from "./bank-info.vue?vue&type=style&index=0&id=44201116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44201116",
  null
  
)

export default component.exports